import React from "react";
import { cn } from "@/lib/utils";

export function StatCard({ label, value, icon: Icon, hint, accent = "#A1A1AA", delay = 0, testId, className }) {
  return (
    <div
      data-testid={testId}
      className={cn("fade-up rounded-xl border border-white/[0.08] bg-[#141417] p-5 transition-colors hover:border-white/[0.15]", className)}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        {Icon && (
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/[0.04]">
            <Icon className="h-4 w-4" strokeWidth={1.5} style={{ color: accent }} />
          </span>
        )}
      </div>
      <div className="mt-3 font-mono text-2xl font-semibold tracking-tight text-foreground">
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
